<template>
  <ion-menu content-id="menu-content" type="overlay">
    <ion-toolbar style="text-align: center;" class="banner-head">
      <img src="/assets/images/logo/rapid-ldpi.png" alt="Rapid Logo" />
      <p class="app-version">{{appVersion.code}} - {{appVersion.description}}</p>
    </ion-toolbar>
    <div class="divider"></div>
    <ion-content class="sidemenu-content">
      <div class="nav-header">
        <div class="nav-info">
          <span
            class="nav-username"
          >{{profile ? profile.firstName : ''}}&nbsp;{{profile ? profile.lastName : ''}}</span>
          <div v-if="showSummary">
            <br />
            <span class="nav-avl-bal">Wallet Balance :&nbsp;</span>
            <span class="nav-avl-amt">&#8377; {{summary ? summary.totalBalance : '0.00' | currency}}</span>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <ion-list lines="none">
        <ion-menu-toggle auto-hide="false" v-for="item in menus" v-bind:key="item.title">
          <ion-item class="menu-name" routerDirection="'root'" button @click="navigate(item.path, item.title)">
            <img :src="getImgUrl(item.icon)" v-bind:alt="item.icon" class="menu-icon" />
            <ion-label>{{item.title}}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
      <div class="divider"></div>
      <ion-list lines="none">
        <ion-menu-toggle auto-hide="false">
          <ion-item
            class="menu-name"
            routerDirection="'root'"
            button
            @click="navigate('/common/about', 'About')"
          >
            <img :src="getImgUrl('info.svg')" class="menu-icon" />
            <ion-label>About</ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="false">
          <ion-item
            class="menu-name"
            routerDirection="'root'"
            button
            @click="navigate('/common/support', 'Support')"
          >
            <img :src="getImgUrl('support.svg')" class="menu-icon" />
            <ion-label>Support</ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="false">
          <ion-item
            class="menu-name"
            routerDirection="'root'"
            button
            @click="navigate('/common/helpVideo', 'HelpVideo')"
          >
            <img :src="getImgUrl('video_icon.svg')" class="menu-icon"/>
            <ion-label>Help Video</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
      <div class="divider"></div>
      <ion-menu-toggle auto-hide="false">
        <ion-item class="menu-name" button @click="logOut()" lines="none">
          <img :src="getImgUrl('402593.svg')" class="menu-icon" />
          <ion-label>Logout</ion-label>
        </ion-item>
      </ion-menu-toggle>
    </ion-content>
  </ion-menu>
</template>

<script>
import { IonMenu, IonContent, IonMenuToggle, IonItem, IonLabel, IonList, IonToolbar } from "@ionic/vue";
import { defineComponent } from "vue"

import { AuthenticationService } from "../../service/account/authenticator.service";
import { ProfilerService } from "../../service/profile/profiler.service";
import { WalletService } from "../../service/wallet/wallet.service";
import { LocalStorage } from "../../data/localstorage";
import { AppUtils } from "../../util/app-utils";
import { Notifications } from '../../service/notifications/notifications.service';
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";



export default defineComponent ({
  name: '',
  components: {
    IonMenu, 
    IonContent, 
    IonMenuToggle, 
    IonItem, 
    IonLabel, 
    IonList, 
    IonToolbar
  },
  data() {
    return {
      profile: null,
      summary: null,
      walletPermission: null,
      showSummary: false,
      selectedMenu: "",
      menus:  [],
      count :null,
      appVersion:""
    }
  },
  async mounted() {
    let user = new LocalStorage().user;
    this.appVersion = await new AuthenticationService().getAppVersion();
    try {
      this.$root.$on("update-count", (count) => {
        // alert(count)
        this.count = count;
      })
    } catch(er) {
      // alert("error" + er)
    }
    if (user) {
      this.menus = new LocalStorage().menus;
      if (this.menus) {
        this.walletPermission = new AppUtils().getUserAccess("30|C");
        this.profile = new LocalStorage().userProfile;
      } else {
        try {
          this.menus = await new AuthenticationService().menuAccessibilitiesOfUser(
            user
          );
          this.menus.forEach(menuItem => {
          if (menuItem.requiredPermision.id === "70|R") {
            (menuItem.icon = "user.svg"), (menuItem.path = "/customer/profile");
          } else if (menuItem.requiredPermision.id === "20|L") {
            (menuItem.icon = "846338.svg"),
            (menuItem.path = "/customer/evehicles");
          } else if (menuItem.requiredPermision.id === "30|C") {
            (menuItem.icon = "wallet.svg"),
            (menuItem.path = "/customer/ewallet");
          } else if (menuItem.requiredPermision.id === "30|L") {
            (menuItem.icon = "wallet.svg"),
            (menuItem.path = "/customer/ewallet");
          } else if (menuItem.requiredPermision.id === "10|C") {
            (menuItem.icon = "calendar.svg"),
            (menuItem.path = "/customer/reservation");
          } else if (menuItem.requiredPermision.id === "10|L") {
            (menuItem.icon = "document.svg"),
            (menuItem.path = "/customer/reservations");
          } else if (menuItem.requiredPermision.id === "10|T") {
            (menuItem.icon = "calendar-1.svg"),
            (menuItem.path = "/admin/reservations");
          } else if (menuItem.requiredPermision.id === "40|L") {
            (menuItem.icon = "plug.svg"), (menuItem.path = "/admin/chargers");
          } else if (menuItem.requiredPermision.id === "50|L") {
            (menuItem.icon = "charging_station.svg"),
            (menuItem.path = "/admin/chargingstations");
          } else if (menuItem.requiredPermision.id === "60|L") {
            (menuItem.icon = "electric-station.svg"),
            (menuItem.path = "/admin/chargerinstallations");
          } else if (menuItem.requiredPermision.id === "80|R") {
            (menuItem.icon = "discount.svg"),
            (menuItem.path = "/customer/discountOffer");
          } else if (menuItem.requiredPermision.id === "90|R") {
            (menuItem.icon = "cop1.svg"),
            (menuItem.path = "/corporate/corporateManage");
          } else if (menuItem.requiredPermision.id === "100|L") {
            (menuItem.icon = "human.svg"),
            (menuItem.path = "/corporate/branchCPO");
          } else if (menuItem.requiredPermision.id === "110|L") {
            (menuItem.icon = "human.svg"),
            (menuItem.path = "/corporate/branchesAndStations");
          }  else if (menuItem.requiredPermision.id === "120|L") {
            (menuItem.icon = "deal12.svg"),
            (menuItem.path = "/corporate/cporeservations");
          } else if (menuItem.requiredPermision.id === "130|L") {
            (menuItem.icon = "dash1.svg"),
            (menuItem.path = "/corporate/cpoAdminDashboard");
          } else if (menuItem.requiredPermision.id === "140|R") {
            (menuItem.icon = "notsvg1.svg"),
            (menuItem.path = "/notifications/Notifications");
          } else if (menuItem.requiredPermision.id === "30000|R") {
            (menuItem.icon = "deal12.svg"),
            (menuItem.path = "/common/log");
          } else if(menuItem.requiredPermision.id === "151|R") {
            (menuItem.icon = "managerUser.svg"),
            (menuItem.path = "/admin/manageUsers");
          } else if(menuItem.requiredPermision.id === "75|L") {
            (menuItem.icon = "dashboard.jpg"),
            (menuItem.path = "/admin/adminDashboard");
          } else if(menuItem.requiredPermision.id === "160|L") {
            (menuItem.icon = "dashboard.jpg"),
            (menuItem.path = "/corporate/cpoReport");
          }
          });
        } catch(error) {
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
        try {
          this.profile = await new ProfilerService().profileOfUser(user);
          new LocalStorage().userProfile = this.profile;

          let userPermissions = await new AuthenticationService().permissionsOfUser(
          user
          );
          new LocalStorage().userPermissions = userPermissions;

          this.walletPermission = new AppUtils().getUserAccess("30|C");

          this.menus = this.menus.filter(
          menuItem =>
            userPermissions.find(
            userPermission =>
              userPermission.id == menuItem.requiredPermision.id
            ) != undefined
          );
          new LocalStorage().menus = this.menus;
        } catch(error) {
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
        
      }
    }
    try {
      if (this.walletPermission) {
        this.showSummary = true;
        // alert("menu wallet")
        this.summary = await new WalletService().summaryOfUser(user);

      }
      
    } catch(error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
    }
    await new Notifications().getunreadNotificationsCount(user.id).then((res) => {
      this.count = res;
    }).catch((error) => {
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    });
    
  },
  methods: {
    getImgUrl(imgpath) {
        return require(`../../../public/assets/images/common/menu_icons/${imgpath}`);
    },
    navigate(url, menu) {
        if(menu != 'Dashboard') {
        this.selectedMenu = menu;
        this.$router.push(url);
        } else {
          this.selectedMenu = menu;
          localStorage.removeItem('fromAdminDashboard');
          localStorage.removeItem('branchInfoForDashboard');
          localStorage.removeItem('branchIDFromDashboard');
          localStorage.removeItem("branchIDFromDashboard");
          // below code is commented for testing purpose
          // this.$router.push({name: url, params: {branchId: ""}});
          localStorage.setItem('branchId', '')
          this.$router.push(url);
        }
    },
    async logOut() {
      try {
        let user = new LocalStorage().user;
        // await new AuthenticationService().signOutUser(user!);
        await new AuthenticationService().signOutUser(user);
        this.$router.push("/logout");

        this.disableBrowserBack();
      } catch (error) {
        window.localStorage.clear();
        this.$router.push("/logout");

        this.disableBrowserBack();
      }
    },
    disableBrowserBack() {
      window.location.href = "/login";
      window.location.hash = "no-back-button";
      window.location.hash = "Again-No-back-button"; //again because google chrome don't insert first hash into history
      window.onhashchange = function() {
        window.location.hash = "no-back-button";
      };
    }
  }
})
</script>

<style scoped>
.app-version {
  margin: 0 0 5px 0;
  padding: 0;
  font-size: 12px;
  opacity: 0.8;
}
.sidemenu-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  --padding: 20px !important;
  opacity: 1;
}
ion-label {
  margin-left: 32px;
}
.menu-icon {
  width: 26px;
  height: 27px;
  /* opacity: 1; */
}
.menu-name {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #29323d;
  /* opacity: 0.75; */
}

.nav-header {
  display: table;
  vertical-align: middle;
  padding: 15px;
}

.nav-header .nav-user-img {
  display: table-cell;
  /* width: 20%; */
  vertical-align: middle;
}

.nav-header .nav-user-img .nav-img {
  height: 35px;
  width: 35px;
  border-radius: 50%;
  opacity: 1;
}

.nav-header .nav-info {
  display: table-cell;
  /* width: 100%; */
  padding-left: 1rem;
  vertical-align: middle;
}

.nav-header .nav-info .nav-username {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #202020;
  opacity: 0.75;
}

.nav-header .nav-info .nav-avl-bal {
  text-align: right;
  font-family: "Roboto";
  font-size: 15px;
  letter-spacing: 0;
  color: #585858;
}

.nav-header .nav-info .nav-avl-amt {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 15px;
  letter-spacing: 0;
  color: #585858;
  opacity: 1;
}

.divider {
  border-top: 2px solid #0000001a !important;
  opacity: 1;
  margin-left: 15px;
  margin-right: 15px;
}

.selected-menu {
  color: #21b24b !important;
}

.selected-menu > img {
  fill: #21b24b;
}
.about-help {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}

/**/
.notifications-count {
  padding: 5px;
  border-radius: 60%;
  width: auto;
  height: auto;
  position: absolute;
  left: 40%;
  top: 0%;
  font-size: 0.6rem;
}
.carter-logo {
  max-width: 66% !important;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
}
</style>
